import { createFileRoute } from "@tanstack/react-router";
import { BillingPage } from "@/components/billing/BillingPage";

/** Keeps return fields untrusted until BillingPage validates their identity; the signed-in organization shell remains authoritative. */
export const Route = createFileRoute("/_layout/billing")({
  validateSearch: (search: Record<string, unknown>) => search,
  component: BillingRoute,
});

function BillingRoute() {
  return <BillingPage search={Route.useSearch()} />;
}
